import { render, staticRenderFns } from "./Vadvantage.vue?vue&type=template&id=02119c57"
import script from "./Vadvantage.vue?vue&type=script&lang=js"
export * from "./Vadvantage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports